export enum DeviceTypeCategory {
  BallTracking = 'BallTracking',
  Spin3dTracking = 'Spin3dTracking',
  BatTracking = 'BatTracking',
}
